import { createPast3lleTemplateTheme } from '@past3lle/theme'

export const pastelleTheme = createPast3lleTemplateTheme('PASTELLE')
